import { round } from '../../../dependencies/utilities.js';

export function buildSpreaderTable(spreaders){

  if (spreaders.length == 0) {
    return null;
    }

  var tab = '<table class="table table-striped">';
  tab += '<thead>';
  tab += '<tr>';
  tab += '<th rowspan="2">Spreader</th>';
  tab += '<th rowspan="2" style="text-align:center;">Cone Setting/Pattern</th>';
  tab += '<th rowspan="2" style="text-align:center;">Swath Width</th>';
  tab += '<th colspan="4" style="text-align:center;">Settings (lbs./1000 sq. ft.)</th>';
  tab += '</tr>';
  tab += '<tr>';
  if (spreaders[0]["App Rate 1"]){tab += '<th style="text-align:center;">Rate 1<br>'+round(spreaders[0]["App Rate 1"],2)+'</th>';};
  if (spreaders[0]["App Rate 2"]){tab += '<th style="text-align:center;">Rate 2<br>'+round(spreaders[0]["App Rate 2"],2)+'</th>';};
  if (spreaders[0]["App Rate 3"]){tab += '<th style="text-align:center;">Rate 3<br>'+round(spreaders[0]["App Rate 3"],2)+'</th>';};
  if (spreaders[0]["App Rate 4"]){tab += '<th style="text-align:center;">Rate 4<br>'+round(spreaders[0]["App Rate 4"],2)+'</th>';};
  tab += '</tr>';
  tab += '</thead>';
  tab += '<tbody>';

  for (var i = 0; i < spreaders.length; i++) {
    var spreader = spreaders[i];
    tab += '<tr>';
    tab += '<td style="text-align:left;">'+spreader["Spreader Manf"]+' '+spreader["Spreader Model"]+'</td>';
    if (spreader["Sprdr Pattern"]){tab += '<td style="text-align:center;">'+spreader["Sprdr Pattern"]+'</td>';}else{tab+='<td style="text-align:center;">--</td>';};
    if (spreader["Sprdr Width"]){tab += '<td style="text-align:center;">'+spreader["Sprdr Width"]+'</td>';}else{tab+='<td style="text-align:center;">--</td>';};
    if (spreader["Spreader set 1"]){tab += '<td style="text-align:center;">'+spreader["Spreader set 1"]+'</td>';};
    if (spreader["Spreader set 2"]){tab += '<td style="text-align:center;">'+spreader["Spreader set 2"]+'</td>';};
    if (spreader["Spreader set 3"]){tab += '<td style="text-align:center;">'+spreader["Spreader set 3"]+'</td>';};
    if (spreader["Spreader set 4"]){tab += '<td style="text-align:center;">'+spreader["Spreader set 4"]+'</td>';};
    tab += '</td>';
  };

  tab += '</tbody>';
  tab += '</table>';

  return tab;

};

export function buildSpreaderCards(spreaders){

	if (spreaders.length == 0) {
		return null;
	}

	var html = ''

	for (var i = 0; i < spreaders.length; i++) {
    var spreader = spreaders[i];
    html += '<div class="spreader-card">';
		html += '<h3>'+spreader["Spreader Manf"]+' '+spreader["Spreader Model"]+'</h3>';
		html += '<ul>'
		if (spreader["Sprdr Pattern"]){ html += '<li>Cone Setting/Pattern: '+spreader["Sprdr Pattern"]+'</li>' }
		if (spreader["Sprdr Width"]){ html += '<li>Swath Width: '+spreader["Sprdr Width"]+'</li>' }

		html += '</ul>'
		html += '<h4>Settings (lbs./1000 sq. ft.)</h4>'
		html += '<ul>'
		if (spreader["Spreader set 1"]){ html += '<li>Rate 1 ('+round(spreader["App Rate 1"],2)+'): '+spreader["Spreader set 1"]+'</li>' }
		if (spreader["Spreader set 2"]){ html += '<li>Rate 2 ('+round(spreader["App Rate 2"],2)+'): '+spreader["Spreader set 2"]+'</li>' }
		if (spreader["Spreader set 3"]){ html += '<li>Rate 3 ('+round(spreader["App Rate 3"],2)+'): '+spreader["Spreader set 3"]+'</li>' }
		if (spreader["Spreader set 4"]){ html += '<li>Rate 4 ('+round(spreader["App Rate 4"],2)+'): '+spreader["Spreader set 4"]+'</li>' }
		html += '</ul>'
    html += '</div>';
  };

	return html;

}

export function startDashTour(){

	var steps = [{
		element: '#foo',
		title: "Hello!",
		intro: "<p>Looks like you are new here so we're going to walk you through a few details to get you oriented.</p><p>This is your <strong>DASHBOARD</strong>, where you'll manage new and existing scenarios. (You don't have any saved scenarios yet.)</p>"
	  },{
		element: '#hamburger-menu',
		title: "Menu",
		intro: "Use the <strong>MENU</strong> button throughout the site to navigate to your dashboard, discover the latest features, and manage your account."
	  },{
		element: '#first',
		title: "Templates",
		intro: "Next, we'll walk you through the process of building a scenario. Press the <strong>Clone This</strong> button on one of the scenario templates to continue with the tour."
	  }]

	var options = {
		disableInteraction: true,
		exitOnOverlayClick: true,
		showBullets: false,
		showStepNumbers: true,
		overlayOpacity: .66,
		nextToDone: true,
		hidePrev: true,
		steps: steps
	  }
	  
	introJs.tour().setOptions(options).start()
}
